import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'

export default function Lab({ lab, enable, canEnableLabs, paperClass }) {
    return (
        <Paper className={'with_header ' + (paperClass || '')} style={{ overflow: 'hidden' }}>
            <div className='quickFlex' style={{ alignItems: 'stretch' }}>
                <div
                    className='hide-xs hide-sm'
                    style={{
                        flex: 1,
                        backgroundImage: `url('${lab.imageUrl}')`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }}
                ></div>
                <div
                    style={{
                        padding: 32,
                        gap: 16,
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1
                    }}
                >
                    <h4>{lab.fullName}</h4>
                    <div>{lab.shortDescription}</div>
                    <div className='quickFlex' style={{ gap: 8 }}>
                        {lab.active ? (
                            <Button disabled={true} className='button-sml' iconLeft={<Icons icon='tick' />}>
                                Enabled
                            </Button>
                        ) : (
                            <Button
                                disabled={!canEnableLabs}
                                className='button-sml button-primary'
                                onClick={() => enable(lab)}
                            >
                                Enable
                            </Button>
                        )}
                        {lab.helpLink && (
                            <Button
                                className='button-ghost button-sml'
                                iconRight={<Icons icon='external' color='black' />}
                                href={lab.helpLink}
                                target='blank'
                            >
                                {lab.helpLink.indexOf('kb.transpond.io') > -1 ||
                                lab.helpLink.indexOf('transpond.io/support') > -1
                                    ? 'Support Docs'
                                    : 'Learn More'}
                            </Button>
                        )}
                    </div>
                    {!!lab.terms && (
                        <a href={lab.terms} target='_blank'>
                            Terms & Conditions
                        </a>
                    )}
                </div>
            </div>
        </Paper>
    )
}
